
export namespace ACApprovalWorkflowConst {
  export enum ApprovalStatus {
    Approved = 'Approved',
    Rejected = 'Rejected'
  }
}